import {Menu, MenuItem} from '@material-ui/core'
import React from 'react'

const MenuActions = ({items = [], onClickItem = (e, action) => {}, onClose = e => {}, ...root}) => {
  return (
    <Menu
      onClose={onClose}
      getContentAnchorEl={null}
      anchorOrigin={{
        horizontal: 'right',
        vertical: 'bottom',
      }}
      transformOrigin={{
        horizontal: 'right',
        vertical: 'top',
      }}
      PaperProps={{
        style: {
          minWidth: '160px',
        },
      }}
      style={{transformOrigin: 'center top', marginTop: '4px'}}
      keepMounted
      {...root}
    >
      {items.map((action, i) => (
        <MenuItem key={i} onClick={e => onClickItem(e, action)} className="font-13 font-color">
          {action.name}
        </MenuItem>
      ))}
    </Menu>
  )
}

export default MenuActions
